import { useLocation } from "react-router-dom";
import { useAppSelector } from "./useRedux";
import { useFetchUserDetails } from "./queries/user";
import {
    allowedUserIdsForDev,
    allowedUserIdsForProd,
} from "../modules/dashboard/constants/constants.dashboard";

export default function useNewBackground() {
    const location = useLocation();
    const { practice } = useAppSelector((state) => state.userPractice);

    const loggedInUser = useFetchUserDetails();

    const isStaging = import.meta.env.VITE_NODE_ENV !== "production";

    let urls = ["/"];

    if (isStaging) {
        urls = urls.concat("/clients");
    }

    const userIds = isStaging ? allowedUserIdsForDev : allowedUserIdsForProd;

    return (
        urls.includes(location.pathname) &&
        Boolean(practice?.provider_id) &&
        userIds.includes(loggedInUser?.data?.user_id || "")
    );
}
